export default "__VITE_ASSET__Cama5rAX__"